import { SapImportTable } from "../component/sapImportCSV/SapImportTable";

export const SapPage = () => {
  return (
    <>
      <SapImportTable type="VEHICLE"/>
    </>
  );
};
